/**
 * Brak daty wygaśnięcia API key lub sentinel OLIVS (DateTime.MinValue) —
 * analogicznie do olivs-client: nie traktuj tego jako twardego wygaśnięcia sesji.
 * @param {string | null | undefined} expiry
 * @returns {boolean}
 */
export function isPlaceholderApiKeyExpiration(expiry) {
  if (expiry == null) return true;
  const s = String(expiry).trim();
  return s === "" || s === "null" || s.startsWith("0001-01-01");
}
